import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../main/main.styles';
import { mixinRobotoBold, mixinRobotoMedium, mixinRobotoRegular } from '../../../../styles';

export const SummaryChatStyles = css`
  ${MainStyles}
  :host {
    position: absolute;
    inset: 0;
    z-index: 1;
    background: var(--fill-color);
    font-size: 0.688rem;
    border-radius: calc(var(--control-corner-radius) * 1px);
    display: flex;
    flex-direction: column;
  }

  :host * {
    ${mixinRobotoRegular}
  }

  .summary-header ::slotted(*),
  .summary-description > *,
  .summary-description ::slotted(*) {
    padding: 0.4rem 1rem;
  }

  .summary-header {
    font-size: 1rem;
    border-bottom: 1px solid var(--border-1);
    ${mixinRobotoBold}
  }

  .summary-description {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 20px 0;
    font-size: 12px;
  }

  .summary-container {
    overflow-y: auto;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
  }

  .table {
    text-align: center;
    width: 100%;
    border-collapse: collapse;
    margin-top: min(30px, 3%);
  }

  .table th,
  .table td {
    padding: 0.45rem 0.4rem;
    font-size: 12px;
  }

  .table tbody th,
  .table tbody td {
    border: 1px solid var(--border-1);
  }

  .table tbody th {
    border-left: none;
    background-color: #26272c;
    color: #879ba6;
    text-align: right;
    width: 188px;
    ${mixinRobotoMedium()}
  }

  .table thead th:nth-child(2) {
    border-right: 1px solid var(--fill-color);
  }

  .red-header {
    background-color: var(--red-darker);
    border-bottom: 1px solid var(--red-lighter);
    color: var(--white);
  }

  .blue-header {
    background-color: var(--blue-darker);
    border-bottom: 1px solid var(--blue-lighter);
    color: var(--white);
  }

  .text-red {
    color: var(--error);
  }

  .highlighted {
    color: var(--yellow);
  }

  .responses {
    padding: 1rem;
    border-top: 1px solid var(--border-1);
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .responses .actions {
    display: grid;
    column-gap: 1rem;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
  }

  .responses .actions ::slotted(zero-button) {
    --design-unit: 2.7;
  }
`;
